const EventsStructure  = {
    eventfeedId: "",
    timeperiod: "",
    eventfeedUUID: "",
    events: [
    {
        eventid: "",
        eventuuid: "",
        eventname: "",
        event_type: "",
        event_timestamp: "",
        createdby: "",
        nmembers: 0,
        eventimageurl: "",
        description: "",
    },
    ]
};

export default EventsStructure;